import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const partyFunc = () => {
  /**
   * おすすめフェアのスライダー
   */
  {
    const $sliderArr = [...document.querySelectorAll('.js-party-slider')];

    $sliderArr.forEach($slider => {
      const swiper = new Swiper($slider, {
        autoplay: { delay: 3000 },
        loop: true,
      });
    });
  }
};
